import { Gutter } from '@/modules/layout/components/gutter';

import { AboPodcasts } from './list/abo-podcasts';
import { withCurrentUserId } from '@/modules/backend/hoc/with-current-userid';
import { SelectAccountBanner } from '@/modules/auth/components/select-account-banner';
import { AnonymousPodcasts } from './list/anonymous-podcasts';
import { ListLayout, PodcastList } from './list/podcast';
import { PodcastListType } from '@nimey/podcast-global-entity';

export const PlayerAllPodcastsWithUser = () => {

  return (
    <Gutter>
        <PodcastList
          listType={PodcastListType.ALL}
          layout={ListLayout.TILES}
          title=''
        />
    </Gutter>
  );
}

const PlayerHomeAnonymous = () => {
  return (
    <Gutter>
      <p>Du bist nicht angemeldet. Wähle jetzt dein Konto oder erstelle ein neues, um alle Funktionen zu nutzten.</p>
      <SelectAccountBanner />
      <AnonymousPodcasts limit={16} />
    </Gutter>
  );
}

export const PlayerAllPodcasts = withCurrentUserId(PlayerAllPodcastsWithUser, PlayerHomeAnonymous)